const Categories = [
  { text: 'Corrective Maintenance', value: 1 },
  { text: 'Custodial', value: 2}
]
export { Categories }